import { Box } from "@mui/material"
import { styled } from "@mui/material/styles";

export const StyledTableButtonGroup = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  "& > :not(:first-child)": {
    marginLeft: "6px"
  }
})
